import React, { useState } from "react";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from "@mui/material";
import ManageSearchOutlinedIcon from "@mui/icons-material/ManageSearchOutlined";

const formatCount = (value) => new Intl.NumberFormat("es-VE").format(Number(value) || 0);

const resultItems = [
  ["rowsAnalyzed", "Registros analizados"],
  ["created", "Nuevas incidencias"],
  ["observed", "Incidencias ya existentes"],
  ["conditionCleared", "Condiciones resueltas"],
  ["reopened", "Incidencias reabiertas"],
];

const MealProjectAnalysis = ({ projectName, projectSelected, loading, result, onAnalyze }) => {
  const [confirmationOpen, setConfirmationOpen] = useState(false);

  const confirmAnalysis = async () => {
    const successful = await onAnalyze();
    if (successful) setConfirmationOpen(false);
  };

  return (
    <Stack spacing={2}>
      <Box>
        <Button
          variant="contained"
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : <ManageSearchOutlinedIcon />}
          onClick={() => setConfirmationOpen(true)}
          disabled={!projectSelected || loading}
        >
          {loading ? "Analizando..." : "Buscar nuevas incidencias"}
        </Button>
      </Box>

      {result && (
        <Alert severity="success" role="status">
          <Typography fontWeight={900} mb={0.5}>Análisis completado</Typography>
          <Typography variant="body2" mb={1.5}>
            {result.created > 0
              ? "La cola de incidencias fue actualizada correctamente."
              : "El análisis terminó correctamente. No se encontraron nuevas incidencias."}
          </Typography>
          <Box
            display="grid"
            gridTemplateColumns={{ xs: "repeat(2, minmax(0, 1fr))", md: "repeat(5, minmax(0, 1fr))" }}
            gap={1.5}
          >
            {resultItems.map(([key, label]) => (
              <Box key={key} minWidth={0}>
                <Typography variant="h6" fontWeight={900}>{formatCount(result[key])}</Typography>
                <Typography variant="caption" color="text.secondary">{label}</Typography>
              </Box>
            ))}
          </Box>
        </Alert>
      )}

      <Dialog
        open={confirmationOpen}
        onClose={() => !loading && setConfirmationOpen(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>Buscar nuevas incidencias</DialogTitle>
        <DialogContent>
          <Stack spacing={1.5} sx={{ pt: 0.5 }}>
            <Typography>Se analizarán los registros disponibles del proyecto:</Typography>
            <Typography fontWeight={900}>{projectName || "Proyecto seleccionado"}</Typography>
            <Alert severity="info">
              El proceso actualizará la cola de incidencias MEAL. No modifica los registros fuente de Salud.
            </Alert>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmationOpen(false)} disabled={loading}>Cancelar</Button>
          <Button variant="contained" onClick={confirmAnalysis} disabled={loading}>
            {loading && <CircularProgress size={16} color="inherit" sx={{ mr: 1 }} />}
            {loading ? "Analizando..." : "Analizar"}
          </Button>
        </DialogActions>
      </Dialog>
    </Stack>
  );
};

export default MealProjectAnalysis;
